import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts"

const MonthlyReport = ({ data }) => {
  const { userMonthly, siteMonthly } = data

  const formatChartData = (monthlyData) => {
    return monthlyData
      .map((item) => ({
        month: new Date(item.month).toLocaleDateString("en-US", { month: "short", year: "numeric" }),
        amount: Number.parseFloat(item.total_amount || 0),
        count: Number.parseInt(item.donation_count || 0),
      }))
      .reverse()
  }

  const userChartData = formatChartData(userMonthly)
  const siteChartData = formatChartData(siteMonthly)

  return (
    <div className="space-y-8">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Monthly Reports</h3>

      {/* Site-wide Report */}
      <div className="bg-gray-50 rounded-lg p-6">
        <h4 className="text-md font-medium text-gray-900 mb-4">Site-wide Monthly Donations</h4>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={siteChartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip
                formatter={(value, name) => [
                  name === "amount" ? `₹${value}` : value,
                  name === "amount" ? "Total Amount" : "Donations",
                ]}
              />
              <Legend />
              <Bar dataKey="amount" fill="#3b82f6" name="Total Amount (₹)" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* User Report */}
      <div className="bg-blue-50 rounded-lg p-6">
        <h4 className="text-md font-medium text-gray-900 mb-4">Your Monthly Donations</h4>
        {userChartData.length > 0 ? (
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={userChartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip
                  formatter={(value, name) => [
                    name === "amount" ? `₹${value}` : value,
                    name === "amount" ? "Amount" : "Donations",
                  ]}
                />
                <Legend />
                <Bar dataKey="amount" fill="#10b981" name="Amount (₹)" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        ) : (
          <div className="text-center py-8">
            <p className="text-gray-500">No donations yet. Start contributing to see your monthly report!</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default MonthlyReport
